























import { defineComponent, computed } from '@vue/composition-api'
import { sortAppByTitle } from "@/apps/FavoriteAppsWidget/utils/sort"
import { useGetters } from 'vuex-composition-helpers'
import AppEditModeComponent from '@/apps/FavoriteAppsWidget/components/AppEditMode.vue'
import MessageComponent from '@/shared/components/Message.vue'
import ErrorMessagesComponent from '@/shared/components/ErrorMessages.vue'

export default defineComponent({
    components: {
        MessageComponent,
        ErrorMessagesComponent,
        AppEditModeComponent
    },
    setup() {
        const { getConfig, getError, getFavoriteApps, getApps } = useGetters([
            'getConfig',
            'getError',
            'getFavoriteApps',
            'getApps'
        ])

        const favoriteAppsOrdered = computed(() => {
            return sortAppByTitle(getFavoriteApps.value)
        })

        const appsOrdered = computed(() => {
            return sortAppByTitle(getApps.value)
        })

        const noFavoriteApps = computed(() => {
            return appsOrdered.value.filter(app => {
                return favoriteAppsOrdered.value.filter(favoriteApp => {
                    return app.title === favoriteApp.title
                }).length === 0
            })
        })

        return {
            getConfig,
            getError,
            favoriteAppsOrdered,
            appsOrdered,
            noFavoriteApps
        }
    }
})
